// The site entry (index.html). No router (a pathname check in App.vue handles /oauth/callback and /open), no moment.
import { createApp } from 'vue';
import { installPlugins } from './setup';
import App from './App.vue';

installPlugins(createApp(App)).mount('#app');
